<div [@fadeIn]="getState()">
  <router-outlet></router-outlet>
</div>
